var BaseView = require('../../../templates/templates-base');
var ContentView = require('../../../components/accordion-list/content');

module.exports = BaseView.extend({
  callbackName: 'callbackAdminLayouts',
  appendThumbnails: ContentView.prototype.appendThumbnails,

  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    this.$el.find('ul.thumbnail-wrapper')
      .toggleClass('thumbnail-wrapper thumbnail-wrapper')
      .css('padding-left', '5px');
  },

  extractData: function (data) {
    var thumbWidth = 255;

    return _.compact(_.map(data, function (item) {
      var fWidth = parseInt(item['format_width']);
      var fHeight = parseInt(item['format_height']);
      var thumbHeight = (fHeight / fWidth) * thumbWidth;

      if (!item['id']) return;

      return {
        id: 'layout-' + item['id'],
        src: item['url'],
        width: thumbWidth,
        height: thumbHeight,
        isNocover: INKIVE.C.USER.IS_SUPER,
        cls: parseInt(item['active']) ? '' : 'grayscale',
        data: {
          count: item['count'],
          set: item['set'],
          num: item['num'],
          orientation: item['orientation'],
          text: item['text'],
          active: item['active']
        }
      };
    }));
  }
});
